import { coerceNumberProperty } from '@angular/cdk/coercion';
import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { SessionRepository } from '@app-core/state/session.repository';
import { TranslocoService } from '@ngneat/transloco';
import { catchError, combineLatest, throwError } from 'rxjs';
import { InterceptorSkip } from 'src/app/defaults/interceptor.constants';
import { CountryRepository } from 'src/app/entities/countries/state/country.repository';
import { RoutePaths } from 'src/app/routes/route-paths.enum';

/**
 *  Interceptor for handling http errors coming from the API.
 */
export const serverErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const sessionRepo = inject(SessionRepository);
  const router = inject(Router);
  const snackbar = inject(MatSnackBar);
  const transloco = inject(TranslocoService);
  const countryRepo = inject(CountryRepository);

  // if the skip interceptor header is present we skip catching the error
  if (req.headers && req.headers.has(InterceptorSkip)) {
    const headers = req.headers.delete(InterceptorSkip);

    return next(req.clone({ headers }));
  }

  return next(req).pipe(
    catchError((err: HttpErrorResponse) => {
      // Handle case when user is logged in the wrong country.
      // We need to check if the api has set a correct country ID
      // and then set the active country by that ID and redirect
      // the user to the correct country URL
      const trueCountryID: number = coerceNumberProperty(
        err.error.redirect_country_id,
        0,
      );
      if (trueCountryID && trueCountryID !== countryRepo.getActiveId()) {
        countryRepo.setActiveCountryByID(trueCountryID);

        location.href =
          location.origin +
          `${countryRepo.getStoreProp('countryParam')}/${
            RoutePaths.ShortageOverview
          }`;
      }

      switch (err.status) {
        case 401:
          // TODO: handle token refresh
          sessionRepo.resetStore();

          combineLatest([
            transloco.selectTranslate<string>(
              'GENERAL.INFO.SESSION_EXPIRED_MESSAGE',
            ),
            transloco.selectTranslate<string>('GENERAL.OK'),
          ]).subscribe({
            next: ([msg, msgOK]) => {
              snackbar.open(msg, msgOK);
              router.navigate([`/${RoutePaths.Login}`]);
            },
          });

          break;

        /* case 403:
          this.handle403(err);
          break;

        case 404:
          this.handle404(err);
          break; */

        default:
          break;
      }

      return throwError(() => err);
    }),
  );
};
